import React from "react";
import styled from "styled-components";

import ImageRenderer from "../../components/components/ImageRenderer";

const Outer = styled.div`
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;
  overflow: hidden;
  border-radius: 8px;
`;

const HEIGHT = 200;

const ArtCard = ({ previewImage, name, className, style, onArtClick }) => {
  return (
    <div
      className={className ?? "d-item col-lg-3 col-md-6 col-sm-6 col-xs-12"}
      style={style}
      onClick={onArtClick}
    >
      <div className="nft__item">
        <div
          className="nft__item_wrap"
          style={{ height: `${HEIGHT}px`, cursor: "pointer" }}
        >
          <Outer>
            <ImageRenderer
              url={previewImage || "./img/background/no_background.png"}
            />
          </Outer>
        </div>
        <div className="nft__item_info mb-2">
          <span id="limit-content-length">
            <h4>{name}</h4>
          </span>
        </div>
      </div>
    </div>
  );
};

export default ArtCard;
